import Modal from 'react-modal';
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';

interface ICustomModal {
  isOpen: boolean;
  isClose: (params: boolean) => void;
  variant:
    | 'video'
    | 'upgrade'
    | 'small'
    | 'editProfile'
    | 'share'
    | 'results'
    | 'delete';
  children: React.ReactNode;
  disableClose?: boolean;
}

Modal.setAppElement('#root');
export default function CustomModal({
  isOpen,
  variant,
  isClose,
  children,
  disableClose,
}: ICustomModal) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  useEffect(() => {
    setModalIsOpen(isOpen);
  }, [isOpen]);
  function closeModal() {
    if (disableClose) {
      return;
    }
    setModalIsOpen(false);
    isClose(false);
  }
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      className={clsx(
        'absolute bg-white cursor-default overflow-y-auto outline-0',
        variant === 'video'
          ? 'w-[672px] max-w-full top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl max-h-[90%]'
          : null,
        variant === 'small'
          ? 'w-[280px] p-6 rounded-6 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl max-h-[90%]'
          : null,
        variant === 'upgrade'
          ? 'w-[386px] max-w-[calc(100%-40px)] p-6 max-tablet:px-4 rounded-6 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl max-h-[90%]'
          : null,
        variant === 'editProfile'
          ? 'tablet:w-[370px] tablet:p-6 tablet:rounded-6 max-tablet:w-screen max-tablet:h-screen max-tablet:py-22 max-tablet:px-5 tablet:top-1/2 tablet:left-1/2 tablet:-translate-x-1/2 tablet:-translate-y-1/2 tablet:shadow-xl'
          : null,
        variant === 'share'
          ? 'w-[370px] max-w-[calc(100%-40px)] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl max-h-[90%] p-6 max-tablet:px-4 rounded-6'
          : null,
        variant === 'results'
          ? 'w-[670px] max-tablet:w-screen max-tablet:h-screen max-tablet:py-22 max-tablet:px-5 tablet:top-1/2 tablet:left-1/2 tablet:-translate-x-1/2 tablet:-translate-y-1/2 shadow-xl tablet:max-h-[90%] tablet:p-6 tablet:rounded-6'
          : null,
        variant === 'delete'
          ? 'w-[552px] max-w-[calc(100%-40px)] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-xl max-h-[90%] p-6 max-tablet:px-4 rounded-6'
          : null
      )}
      overlayClassName={
        'fixed w-screen h-screen top-0 left-0 bg-black/[0.6] cursor-pointer z-20'
      }
      bodyOpenClassName={
        variant === 'editProfile' || variant === 'results'
          ? 'fullModalOpen overflow-hidden'
          : ''
      }
    >
      {children}
    </Modal>
  );
}
